import Login from "@/Pages/Auth/Login.vue";
import Register from "@/Pages/Auth/Register.vue";
import ForgotPassword from "@/Pages/Auth/ForgotPassword.vue";
import ResetPassword from "@/Pages/Auth/ResetPassword.vue";
import Profile from "@/Pages/Auth/Profile.vue";
import TermsAndConditions from "../Pages/Auth/TermsAndConditions.vue";

export default [
    {
        path: "/login",
        component: Login,
        name: "login",
        meta: {layout: "guest"},
    },
    {
        path: "/register",
        component: Register,
        name: "register",
        meta: {layout: "guest"},
    },
    {
        path: "/forgot-password",
        component: ForgotPassword,
        name: "forgot-password",
        meta: {layout: "guest"},
    },
    {
        path: "/password-reset/:token",
        component: ResetPassword,
        name: "reset-password",
        meta: {layout: "guest"},
    },
    {path: "/profile", component: Profile, name: "profile.edit"},
    {path: "/terms", component: TermsAndConditions, name: "terms"},
];
